import React from 'react'

import Simulations from './Simulations.js'
import Listeners from './Listeners.js'
import { getJWTUsername } from './storage.js'

function BeeCommandcenter({handleLogout}) {
  let username = getJWTUsername();

  return (
    <div className="container is-max-desktop">
      <h1 className="has-text-weight-bold is-size-1 honey-text-font-family honey-text">HoneyShare Command and Control</h1>
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family honey-text-common">User: {username}</h5>
      <Simulations />
      <Listeners />
    </div>
  );
}

export default BeeCommandcenter;
